import { resetFileInput } from "./file-selector-functionality";
import { convertHeicToJpg } from "./heicConverter"

export const inputFileToImage = (files, el) => {
  if(files?.length === 0) return; 
  const filename = files[0].name;
  const fileType = filename.split(".").pop();
  const imgEl =
    el.parentElement.querySelector(".file-selectors  img") ||
    el.parentElement.querySelector("img");
  const trashButton = el.parentElement.querySelector(".trash");
  let rmoFormSupportedExtentions = ['jpeg', 'jpg', 'png', 'pdf', 'gif', 'bmp', 'tiff','heic','heif'];
  if (rmoFormSupportedExtentions.indexOf(fileType?.toLowerCase()) === -1) {
    showFileValidationMessage(el, "text-format-file-error");
    resetFileInput(el, imgEl, trashButton);
  } else if(files[0].size >= 3.5e+6) {
    showFileValidationMessage(el, "text-size-error");
    resetFileInput(el, imgEl, trashButton);
  } else {
    hideFileValidationMessage(el);
    
    const figCaption =
      el.parentElement.parentElement.querySelector(".figcaption-value");
    figCaption.innerHTML = filename;
    figCaption.setAttribute('title', filename)
    if(fileType.toLowerCase() !== 'pdf') {
      if(fileType.toLowerCase() === 'heic'){
        let srcData =  convertHeicToJpg(el.files[0])
        imgEl.src = URL.createObjectURL(srcData);
      }
      else{ imgEl.src = URL.createObjectURL(el.files[0]);}
     
      imgEl.onload = function () {
        URL.revokeObjectURL(imgEl.src);
      };
    } else {
      imgEl.src = '';
    }
    imgEl?.classList.remove("d-none");
    trashButton?.classList.remove("d-none");
  }
}


export const changeFileInputListener = (parentEl) => {
  const inputFileEls = parentEl.querySelectorAll("input[type=file]");
  Array.from(inputFileEls).forEach((inputEl) => {
    inputEl.addEventListener("change", (e) => {
      inputFileToImage(e.target.files, e.target)
    });
  });
};
